import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	nudgeCtaBack: {
		id: 'software-onboarding-nudges--next.common.nudge-cta-back',
		defaultMessage: 'Back',
		description:
			'This is the text that is on a button in the nudge to indicate the user needs to click to move to the previous item.',
	},
	nudgeCtaNext: {
		id: 'software-onboarding-nudges--next.common.nudge-cta-next',
		defaultMessage: 'Next',
		description:
			'This is the text that is on a button in the nudge to indicate the user needs to click to move to the next item.',
	},
	nudgeCtaDone: {
		id: 'software-onboarding-nudges--next.common.nudge-cta-done',
		defaultMessage: 'Done',
		description:
			'This is the text that is on a button in the nudge to indicate the user is done with the current sequence.',
	},
	nudgeCtaCancel: {
		id: 'software-onboarding-nudges--next.common.nudge-cta-cancel',
		defaultMessage: 'Cancel',
		description:
			'This is the text that is on a button in the nudge to indicate the user wants to cancel the current sequence.',
	},
	nudgeCtaLearnMore: {
		id: 'software-onboarding-nudges--next.common.nudge-cta-learn-more',
		defaultMessage: 'Learn more',
		description:
			'This is the text that is on a link in the nudge to navigate the user to more information.',
	},
	nudgeCtaFinish: {
		id: 'software-onboarding-nudges--next.common.nudge-cta-finish',
		defaultMessage: 'Finish',
		description:
			'This is the text that is on a button in the nudge to indicate the user is finished with the current sequence.',
	},
	nudgeCtaGotIt: {
		id: 'software-onboarding-nudges--next.common.nudge-cta-got-it',
		defaultMessage: 'Got it',
		description:
			'This is the text that is on a button in the nudge to indicate the user is done with the current sequence.',
	},
});
